import { RiArrowLeftLine } from '@remixicon/react';
import { Footer } from '../components/layout/Footer';

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-surface-page">
      {/* Top bar */}
      <div className="bg-brand px-5 lg:px-10 py-4 flex items-center gap-4">
        <a href="/" className="flex items-center gap-1.5 text-white/80 hover:text-white font-display text-[14px] transition-colors">
          <RiArrowLeftLine className="h-4 w-4" />
          Retour
        </a>
        <img src="/new_assets/LogoH.svg" alt="idaNroh" className="h-8 w-auto" draggable={false} />
      </div>

      {/* Contenu */}
      <div className="max-w-[720px] mx-auto px-5 lg:px-8 py-10 pb-16">
        <div className="bg-white rounded-2xl border border-line-light p-8 lg:p-10">

          <h1 className="font-display font-bold text-[26px] text-ink mb-1">
            Politique de confidentialité
          </h1>
          <p className="font-display text-[13px] text-ink-faint mb-8">
            Dernière mise à jour : juillet 2026
          </p>

          <Section title="Données collectées">
            <p>idaNroh collecte uniquement les données nécessaires à son fonctionnement :</p>
            <ul>
              <li><strong>Historique de recherches</strong> : stocké localement dans ton navigateur (localStorage). Aucune donnée n'est envoyée à nos serveurs.</li>
              <li><strong>Préférences</strong> : langue choisie (FR/AR) et consentement aux cookies, conservés en localStorage.</li>
              <li><strong>Cookies analytiques</strong> : Google Analytics (si accepté via la bannière), pour mesurer l'audience de manière anonyme.</li>
              <li><strong>Cookies publicitaires</strong> : Google AdSense (si accepté via la bannière), pour afficher des annonces contextuelles.</li>
            </ul>
          </Section>

          <Section title="Finalité du traitement">
            <p>Ces données servent exclusivement à :</p>
            <ul>
              <li>Mémoriser tes préférences de navigation et ton historique de trajets.</li>
              <li>Améliorer le service via des statistiques d'usage anonymes.</li>
              <li>Financer le service via l'affichage d'annonces non intrusives.</li>
            </ul>
            <p className="mt-3">
              Aucune donnée personnelle n'est vendue ni transmise à des tiers autres que Google (dans le cadre d'Analytics et AdSense), et uniquement si tu as donné ton consentement.
            </p>
          </Section>

          <Section title="Cookies">
            <p>Trois catégories de cookies peuvent être utilisées :</p>
            <ul>
              <li><strong>Essentiels</strong> : indispensables au fonctionnement (consentement, préférences). Toujours actifs.</li>
              <li><strong>Analytiques</strong> : Google Analytics. Actifs uniquement si tu as cliqué sur « Accepter ».</li>
              <li><strong>Publicitaires</strong> : Google AdSense. Actifs uniquement si tu as cliqué sur « Accepter ».</li>
            </ul>
            <p className="mt-3">
              Tu peux refuser les cookies non essentiels depuis la bannière qui s'affiche à ta première visite, ou en vidant les données de ton navigateur.
            </p>
          </Section>

          <Section title="Tes droits">
            <p>
              Tu peux à tout moment demander l'accès, la rectification ou la suppression des données te concernant en nous contactant via le formulaire disponible sur le site.
              Les données en localStorage sont sous ton contrôle direct : tu peux les effacer depuis les paramètres de ton navigateur.
            </p>
          </Section>

          <Section title="Durée de conservation" last>
            <p>
              Les données en localStorage sont conservées jusqu'à ce que tu vides le cache de ton navigateur ou désinstalles l'application. Les cookies Google sont soumis aux politiques de conservation de Google (en général 13 mois pour Analytics).
            </p>
          </Section>

        </div>
      </div>

      <Footer />
    </div>
  );
}

function Section({ title, children, last = false }: { title: string; children: React.ReactNode; last?: boolean }) {
  return (
    <div className={last ? '' : 'mb-8 pb-8 border-b border-surface-ui'}>
      <h2 className="font-display font-bold text-[17px] text-ink mb-3">{title}</h2>
      <div className="font-display text-[14px] text-ink-secondary leading-relaxed space-y-2 [&_ul]:list-disc [&_ul]:ps-5 [&_ul]:space-y-1.5 [&_strong]:font-semibold [&_strong]:text-ink">
        {children}
      </div>
    </div>
  );
}
